import React from 'react'
import injectStyles from 'react-jss'
import { useSelector } from 'react-redux'

import { styles } from './styles'
import StyledBreadcrumbs from '../../Components/StyledBreadcrumbs'
import { PATHS } from '../../Config/Routing/paths'
import { PageTitle } from '../../Components/PageTitle'
import Card from './components/Card'
import { ROLE_CLIENT, ROLE_CLIENT_ADMIN } from '../../shared/constants'
//import BillingIcon from './icons/BillingIcon'
import CouponIcon from './icons/CouponIcon'
import { useHistory } from 'react-router-dom'
import { authorization } from '../../Module/Auth/Auth'
import BreadcrumbsSettingsIcon from '../../Assets/Images/icons/breadcrumbsSettings'
import classNames from 'classnames'
import { UserManagementCardIcon } from '../../Assets/Images/icons/UserManagementCardIcon'
import { Folder } from '../../Assets/Images/icons/folder'
import { CONFIG } from '../../Config/config'
const ClientSettings = ({ classes, url, userRole }) => {
  const history = useHistory()
  const { client } = authorization.getUser()
  const clientView = useSelector(state => state.clients.clientView)

  const CARDS = [
    {
      title: 'User management',
      description: 'Invite your team, create users and roles',
      buttonText: 'Manage users',
      icon: <UserManagementCardIcon />,
      onClick: () => {
        history.push(`${url}${PATHS.clientSettings.userManagement}`)
      },
      allowedRoles: [ROLE_CLIENT_ADMIN],
    },
    // {
    //   title: 'Billing',
    //   description: 'Access your invoices and add payment method',
    //   buttonText: 'Access billing',
    //   icon: <BillingIcon />,
    // },
    {
      title: 'Coupons',
      description: 'Create your coupons',
      buttonText: 'Create coupon',
      icon: <CouponIcon />,
      onClick: () => {
        history.push(`${url}${PATHS.clientSettings.coupons}`)
      },
      allowedRoles: [ROLE_CLIENT, ROLE_CLIENT_ADMIN],
    },
    {
      title: 'Secure file transfer',
      description: 'Upload files securely via SFTP to be shared with Promofy',
      buttonText: 'Upload files',
      icon: <Folder />,
      onClick: () => {
        window.location.href = `${CONFIG.NEXT_BASE_URL}/dashboard/${
          client.id
        }/integrations/sftp`
      },
      allowedRoles: [ROLE_CLIENT, ROLE_CLIENT_ADMIN],
      enabled: clientView?.id ? clientView.sftpEnabled : false,
    },
  ]

  const filterCards = CARDS.filter(
    card =>
      card.enabled !== false &&
      (!card.allowedRoles || card.allowedRoles.includes(userRole)),
  )

  return (
    <div className={classes.container}>
      <StyledBreadcrumbs
        icon={<BreadcrumbsSettingsIcon />}
        breadcrumbs={[
          {
            label: 'Settings',
          },
        ]}
      />
      <PageTitle className={classes.title}>Settings</PageTitle>
      <div
        className={classNames(classes.cardWrapper, 'cardWrapper')}
        cypress_id={'settingsCardWrapper'}
      >
        {filterCards.map(card => (
          <Card
            key={card.title}
            title={card.title}
            description={card.description}
            buttonText={card.buttonText}
            icon={card.icon}
            onClick={card.onClick}
          />
        ))}
      </div>
    </div>
  )
}

export default injectStyles(styles)(ClientSettings)
